import { render, staticRenderFns } from "./EditDevice.vue?vue&type=template&id=0c1938e7&scoped=true"
import script from "./EditDevice.vue?vue&type=script&lang=ts"
export * from "./EditDevice.vue?vue&type=script&lang=ts"
import style0 from "./EditDevice.vue?vue&type=style&index=0&id=0c1938e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1938e7",
  null
  
)

export default component.exports